import { render, staticRenderFns } from "./ProductsHome.vue?vue&type=template&id=63104d42&"
import script from "./ProductsHome.vue?vue&type=script&lang=js&"
export * from "./ProductsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports